import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class NotificationService {
    private readonly snackBar = inject(MatSnackBar);

    open(message: string, data?: { action?: string; duration?: number }): void {
        this.snackBar.open(message, data?.action, {
            panelClass: 'snack-bar-error',
            horizontalPosition: 'right',
            verticalPosition: 'top',
            duration: data?.duration ?? 2000
        });
    }
}
